const URL_API = process.env.REACT_APP_API_URL;

const FUKOWebApp = {
  requestHeader: ({ token }: { token?: string }) => {
    const selectedBranchId = localStorage.getItem('fuko_selected_branch_id') || localStorage.getItem('active_branch_id');
    const selectedShopId = localStorage.getItem('shop_id') || localStorage.getItem('active_shop_id');
    const businessType = localStorage.getItem('business_type') || localStorage.getItem('shop_business_type');
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(selectedBranchId ? { 'X-Branch-ID': selectedBranchId } : {}),
      ...(selectedShopId ? { 'X-Shop-ID': selectedShopId, 'X-Business-ID': selectedShopId } : {}),
      ...(businessType ? { 'X-Business-Type': businessType } : {}),
    };
  },
  url: URL_API,
};

const config = {
  FUKOWebApp,
  // Add platform config
};

export default config;
